// extracted by mini-css-extract-plugin
export default {"card":"DiscountMobileList_card__dFKz9","name":"DiscountMobileList_name__p3zVH","moreBtn":"DiscountMobileList_moreBtn__vGylB"};